import SearchResults from '../../Views/Search/Results';

export default [
    {
        path:'/search/results',
        component:SearchResults,
        name:'search.results',
    },
];
